var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#FF870F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.655 8.83203H22.3359C22.9317 8.83203 23.4634 8.85039 23.94 8.91456C26.4792 9.19872 27.1667 10.3904 27.1667 13.6537V19.447C27.1667 22.7104 26.4792 23.902 23.94 24.1862C23.4634 24.2504 22.9409 24.2687 22.3359 24.2687H13.655C13.0592 24.2687 12.5275 24.2504 12.0509 24.1862C9.51171 23.902 8.82422 22.7104 8.82422 19.447V13.6537C8.82422 10.3904 9.51171 9.19872 12.0509 8.91456C12.5275 8.85039 13.0592 8.83203 13.655 8.83203Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 14.625H22.8225",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1777 19.9316H13.1961H22.8302",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 27.166H22.5827",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5939 14.6087H13.6022",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6193 14.6087H16.6275",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcYellow);
export default __webpack_public_path__ + "static/media/pc-yellow.78715d9e0e37923e3445a1b2d57a9780.svg";
export { ForwardRef as ReactComponent };